import { Box, Image, Text } from "@chakra-ui/react";
import Button from "@verivest/shared-components/src/buttons/Button";
import { ManagerEmailSupportLink } from "@verivest/shared-components/src/links/ManagerEmailSupportLink";
import React from "react";
import { stringToPlural } from "../../../utils/utils";
import { InvestorPortalEmptyStatusProps } from "./InvestorPortalEmptyStatus.types";

export const InvestorPortalEmptyStatus: React.FC<
  InvestorPortalEmptyStatusProps
> = ({
  target,
  imgSrc,
  title,
  subTitle,
  buttonOnClick,
  buttonLabel,
  buttonTo,
  ...rest
}) => {
  const normalizedTarget = target?.toLowerCase() || "";
  return (
    <Box textAlign={"center"} {...rest}>
      {imgSrc && (
        <Image mt={10} mx={"auto"} maxW={"450px"} w={"100%"} src={imgSrc} />
      )}
      <Text textStyle={"h4"} mt={6.5}>
        {title || `You have no ${stringToPlural(normalizedTarget)} available`}
      </Text>
      <Text textStyle={"bodyLarge"} mt={5}>
        {subTitle ||
          `Once you make your first ${normalizedTarget}, it will appear here.`}
      </Text>
      {(buttonOnClick || buttonTo) && buttonLabel && (
        <Button
          mt={5}
          mx={"auto"}
          to={buttonTo}
          onClick={buttonOnClick}
          isLarge
          width="fit-content"
        >
          {buttonLabel}
        </Button>
      )}
      <Text textStyle={"bodyRegular"} mt={12}>
        For assistance, please contact <ManagerEmailSupportLink />.
      </Text>
    </Box>
  );
};
